<template>
  <div class="no-box-shadow-card">
    <div class="card border-color-select border-top-none"
         v-for="(ressource, index) of ressourceADate"
         :key="index">
      <div class="card-header">
        <a class="card-header-icon is-cursor-pointer height-60"
           @click="selectTechnicien(technicienId, ressource.datePlanification)">
          <b-icon :icon="isIconSelect && ressource.datePlanification === technicienSelect.date
          ? 'check-circle' : 'checkbox-blank-circle-outline'"
                  :type="isIconSelect && ressource.datePlanification === technicienSelect.date
                  ? 'is-primary' : ''">
          </b-icon>
        </a>
        <div class="columns is-marginless  mgt-20px full-width">
          <div class="column is-paddingless is-3">
            <div class="columns is-multiline">
              <div class="column is-12 pdv-0
              is-size-6 has-text-weight-bold has-text-link">
                {{ ressource.datePlanification | formatDate }}
              </div>
              <div class="column is-12 pdv-0 is-size-7 has-text-default">
                {{ $t('chargeTravailTech.ressourceAndAffectationInfo.nbOts',
                { nbOt: ressource.nbOts }) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    ressourceADate: {
      type: Array,
      required: true,
    },
    isIconSelect: {
      type: Boolean,
      required: true,
    },
    technicienSelect: {
      type: Object,
      required: true,
    },
    technicienId: {
      type: String,
      required: true,
    },
  },
  methods: {
    selectTechnicien(technicienId, date) {
      this.$emit('updateTechnicienSelect', technicienId, date);
    },
  },
};

</script>
